import { MakeCall } from './createMakeCall';
import { User } from './types/User';

export interface Query {
  expand?: 'defaults';
}

const getUser =
  (makeCall: MakeCall) =>
  (userId: number | 'me' = 'me', query?: Query) =>
    makeCall<User>('GET', `/api/v2/user/${userId}`, {
      query,
    });

export { getUser };
